var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4274 2.5783C20.9274 2.0673 20.1874 1.8783 19.4974 2.0783L3.40742 6.7273C2.67942 6.9293 2.16342 7.5063 2.02442 8.2383C1.88242 8.9843 2.37842 9.9323 3.02642 10.3283L8.05742 13.4003C8.57342 13.7163 9.23942 13.6373 9.66642 13.2093L15.4274 7.4483C15.7174 7.1473 16.1974 7.1473 16.4874 7.4483C16.7774 7.7373 16.7774 8.2083 16.4874 8.5083L10.7164 14.2693C10.2884 14.6973 10.2084 15.3613 10.5234 15.8783L13.5974 20.9283C13.9574 21.5273 14.5774 21.8683 15.2574 21.8683C15.3374 21.8683 15.4274 21.8683 15.5074 21.8573C16.2874 21.7583 16.9074 21.2273 17.1374 20.4773L21.9074 4.5083C22.1174 3.8283 21.9274 3.0883 21.4274 2.5783",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01052 16.8078C2.81852 16.8078 2.62652 16.7348 2.48052 16.5878C2.18752 16.2948 2.18752 15.8208 2.48052 15.5278L3.84552 14.1618C4.13852 13.8698 4.61352 13.8698 4.90652 14.1618C5.19852 14.4548 5.19852 14.9298 4.90652 15.2228L3.54052 16.5878C3.39452 16.7348 3.20252 16.8078 3.01052 16.8078ZM6.77172 18.0002C6.57972 18.0002 6.38772 17.9272 6.24172 17.7802C5.94872 17.4872 5.94872 17.0132 6.24172 16.7202L7.60672 15.3542C7.89972 15.0622 8.37472 15.0622 8.66772 15.3542C8.95972 15.6472 8.95972 16.1222 8.66772 16.4152L7.30172 17.7802C7.15572 17.9272 6.96372 18.0002 6.77172 18.0002ZM7.02542 21.5682C7.17142 21.7152 7.36342 21.7882 7.55542 21.7882C7.74742 21.7882 7.93942 21.7152 8.08542 21.5682L9.45142 20.2032C9.74342 19.9102 9.74342 19.4352 9.45142 19.1422C9.15842 18.8502 8.68342 18.8502 8.39042 19.1422L7.02542 20.5082C6.73242 20.8012 6.73242 21.2752 7.02542 21.5682Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.bd0ece25e58daa121d69e77b3fddb6b3.svg";
export { ForwardRef as ReactComponent };